import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import * as yup from "yup";
import {
  Button,
  Dropdown,
  Form,
  Input,
  Label,
  Loader,
} from "semantic-ui-react";

import { Container, Content, Title, InputColor } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { StyledLabel } from "../../Cupons/styled";

const CertificadoOldDate = (props) => {
  const [idAluno, setIdAluno] = useState();
  const [alunosOptions, setAlunosOptions] = useState();
  const [alunoSearch, setAlunoSearch] = useState();

  const [idCurso, setCurso] = useState();
  const [date, setDate] = useState();
  const [loading, setLoading] = useState(false);

  const create = async () => {
    console.log({
      id_aluno: idAluno,
      id_curso: idCurso,
      _escape_: true,
      novo: true,
      date,
    });

    try {
      setLoading(true);
      api.post("/admin/certificate", {
          userId: idAluno,
          courseId: idCurso,
          needRegenerate: true,
          manualConclusionDate: date,
        })
        .then((res) => {
          swal("Certificado gerado com sucesso", `${res.data.url}`, "success");
          setLoading(false);
        })
        .catch((err) => {
          swal("Problema ocorrido, verifique todos os campos", err, "error");
          setLoading(false);
        });
    } catch (err) {
      swal("Erro!", `${err}`, "error");
      return;
    }
  };

  const handleAlunoSearchChange = useCallback((e) => {
    const search = e.target.value;
    setAlunoSearch(search);
    api.get(`alunos?search=${search}&limit=15`).then((res) => {
      if (res.data.length > 0) {
        const options = res.data.map((pessoa, index) => ({
          key: index,
          text: `(${pessoa.email}) [ID: ${pessoa.id}]`,
          value: pessoa.id,
        }));
        setAlunosOptions(options);
        return;
      }
      setAlunosOptions([]);
    });
  });

  const handleAlunoChange = useCallback((e, { options, value }) => {
    const text = options.find((option) => option.value === value).text;
    setIdAluno(value);
    setAlunoSearch(text);
  }, []);

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Criar certificado</Title>

            <Form>
              <Form.Field>
                <field>
                  <Label>Selecione o aluno</Label>
                  <Dropdown
                    placeholder="Busque pelo ID, Nome ou E-mail do aluno"
                    fluid
                    search
                    selection
                    options={alunosOptions}
                    onChange={handleAlunoChange}
                    searchQuery={alunoSearch}
                    onSearchChange={handleAlunoSearchChange}
                    value={idAluno}
                  />
                </field>
              </Form.Field>

              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Id do curso"
                  placeholder="Id do curso"
                  value={idCurso}
                  type="number"
                  onChange={(e) => {
                    setCurso(e.target.value);
                  }}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Data"
                  placeholder="Data"
                  type="date"
                  value={date}
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                />
              </Form.Group>

              <Form.Group>
                <Form.Field control={Button} onClick={() => create()}>
                  Criar Certificado
                </Form.Field>
                <Link to="/admin">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(CertificadoOldDate);
